<template>
  <div class="desc-template">
    <material-list class="material-list" :groupList="groupList" v-if="groupList.length>0"></material-list>
    <graphic-editor class="graphic-editor" ref="graphicEditor" :desc="desc" v-if="desc.id"></graphic-editor>
  </div>
</template>
<script>
import axios from '@/common/utils/axios'
import MaterialList from './components/material-list.vue'
import GraphicEditor from './components/graphic-editor.vue'
import { useRoute } from 'vue-router'
import { ref, provide, onMounted, reactive } from 'vue'
export default {
  components: { MaterialList, GraphicEditor },
  setup () {
    const id = useRoute().query.id

    const groupList = reactive([])
    const desc = reactive({})
    onMounted(async () => {
      const loading = window.$loading()
      await Promise.all([queryGroupList(), queryDesc()])
      loading.close()
    })

    /**
     * 查询模板分类
     */
    const queryGroupList = () => {
      // TODO 这里要换成静态变量
      return new Promise((resolve) => {
        axios('/admin/template/group/list', { type: 3 }, { loading: false })
          .then(res => {
            groupList.push(...(res.templateGroupList || []))
            resolve()
          }).catch(_ => { })
      })
    }
    /**
     * 查询图文详情
     */
    const queryDesc = () => {
      return new Promise((resolve) => {
        axios('/admin/desc/info', {
          descId: id
        }, { loading: false })
          .then(res => {
            desc.id = res.desc.id
            desc.iid = res.desc.iid
            desc.text = res.desc.text
            resolve()
          }).catch(_ => { })
      })
    }

    /**
     * 插入模板至编辑器
     */
    const graphicEditor = ref()
    function insertContent (htmlTemplate) {
      graphicEditor.value.insertContent(htmlTemplate)
    }
    provide('insertContent', (content) => insertContent(content))

    return { groupList, desc, graphicEditor, insertContent }
  }
}
</script>
<style lang="scss" scoped>
$material-list-width : 460px;
$gutter-width: 10px;
.desc-template{
  display: flex;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  background-color: $bg-gray !important;
  .material-list {
    background-color: #fff;
    width: $material-list-width;
    margin-right: $gutter-width;
  }
  .graphic-editor{
    flex: 1;
  }
}
</style>
